import React, { useState, useMemo, useContext, useEffect, useCallback } from 'react'
import Loader from '../../../../Components/Loader'
import NoDataPlaceholder from '../../../../Components/shared/NoDataPlaceholder'
import Pagination from '../../../../Components/Pagination'
import SortIcon from 'mdi-react/SortIcon'
import SortAscendingIcon from 'mdi-react/SortAscendingIcon'
import SortDescendingIcon from 'mdi-react/SortDescendingIcon'
import OverflowToolTip from '../../../../Components/shared/OverflowToolTip'
import { Link, NavLink, useLocation } from 'react-router-dom'
import { UserContext } from '../../../../Contexts/UserContext'
import Constants from '../../../../Constants'
import moment from 'moment';
import { reInvestorListUrl,getPEGlobalSearchCompaniesApi } from '../../../../Config/config'
import axios from 'axios'
import routePathSegments, { routeNames } from '../../../../routeSegments'
import AddNotePopover from '../../../../Components/shared/AddNotePopover'
import { TableDataContext } from '../../../../Contexts/TableDataContext'
import { PeFilterContext } from '../../../../Contexts/PeFilterContext'
import { useRef } from 'react'
import { getSection } from '../../../../Utils/utils'
import RandomLogo from '../../../../Components/RandomLogo'
import CompanyLogo from '../../../../Components/CompanyLogo'
import '../../../../Components/TableView.css'
import '../../../../Utils/Common.css'
import DeleteItemsFromGroup from '../../../../Components/shared/DeleteItemsFromGroup';
import { toast } from 'react-toastify'
import TwolineOverflowToolTip from '../../../../Components/shared/TwolineOverflowToolTip'
import NewLogo from '../../../../Components/NewLogo'

/** The above code is a JavaScript function called "Table" that takes in several parameters. It is a
component that renders a table with data fetched from an API. */
function Table({ columns, category , orderBy, order,sub_type_master_id}) {
  const { rows, setRows, setAllDealIds, setTableInvestorId, data, setData, setIsDataLoad, currentPage, setCurrentPage,setCurrentFilter, globalSearchResult, setGlobalSearchResult} = useContext(TableDataContext);
  const { monthPickerValue, refineSearchFilters ,groupId , resetDealsByFilter} = useContext(PeFilterContext);
  const [sort, setSort] = useState({ order: order, orderBy: orderBy })
  const abortControllerRef = useRef();
  const [activePage, setActivePage] = useState(currentPage)
  const location = useLocation();
  const locState = location.state && location.state?.legacyFilterData || location.state?.gsResults
  useEffect(()=>{
    console.log("jjjhhk inv" , location?.key)
    resetDealsByFilter();
  },[location?.key])
  const { getToken, logout } = useContext(UserContext);
  const [isLoading, setIsLoading] = useState(false);
  const isFromGlobalSearch = ()=> refineSearchFilters[location.pathname]?.globalSearch?.length > 0 ? true : false
  const pathKey = location.pathname.split("/").slice(0, 3).join("/");

  const[reload, setReload] = useState(false)

/**
 * The function `findActivePage` sets the current page, renders a table with specified parameters, and
 * sets the loading state to true.
 * @param page - The page parameter is used to specify the current page number.
 */
  const findActivePage = (page) => {
    setCurrentPage(page)
    tableRender(page, monthPickerValue, sort.orderBy, sort.order ,groupId)
    setIsLoading(true)
    
  }

  const dealCategory = category == "re-investments"
      ? "RE_INV"
      : category == "re-exits"
        ? "RE_EXIT"
        : category == "re-ipo"
          ? "RE_IPO"
          :""

  const sortBy = dealCategory == "RE_INV"
      ? "latest_inv_deal_date_num"
      : dealCategory == "RE_EXIT"
        ? "investor_sort"
        : dealCategory == "RE_IPO"
          ? "investor_sort"          
          :""

          const globalSearchCategory = category.replace("-", "_")+"_ids";

  const getGlobalSearchIds = async () => {
    if (!isFromGlobalSearch()) return { investorIds: [], companyIds: [] };
    
    try {
      // Check if we have navigation state with global search information
      let sourceCollection = location.state?.sourceCollection || location.state?.globalSearchCollection;
      let searchQuery = location.state?.globalSearchQuery;
      let searchType = location.state?.globalSearchType;
      let resultCount = location.state?.globalSearchResultCount;
      let isFromGlobalSearchFlag = location.state?.isFromGlobalSearch;
      
      // If we don't have search parameters from navigation state but have global search results,
      // try to get them from a stored context or derive them
      if (!searchQuery && globalSearchResult && Object.keys(globalSearchResult).length > 0) {
        console.log('RE Investor Table: In global search context but missing search parameters, checking for stored values...');
        
        const storedSearchData = sessionStorage.getItem('globalSearchContext');
        if (storedSearchData) {
          try {
            const parsed = JSON.parse(storedSearchData);
            searchQuery = searchQuery || parsed.searchQuery;
            searchType = searchType !== undefined ? searchType : parsed.searchType;
            resultCount = resultCount || parsed.resultCount;
            isFromGlobalSearchFlag = isFromGlobalSearchFlag || parsed.isFromGlobalSearch;
            console.log('RE Investor Table: Retrieved search parameters from session storage:', parsed);
          } catch (e) {
            console.error('RE Investor Table: Error parsing stored search data:', e);
          }
        }
      }
      
      // Store current search context for future use
      if (searchQuery !== undefined && searchType !== undefined) {
        const searchContext = {
          searchQuery,
          searchType,
          resultCount: resultCount || 1000,
          isFromGlobalSearch: isFromGlobalSearchFlag || true,
          timestamp: Date.now()
        };
        sessionStorage.setItem('globalSearchContext', JSON.stringify(searchContext));
      }
      
      // Map to collection name for fresh searches
      const targetCollection = 're_investor';
      
      console.log('RE Investor Table - Navigation state:', location.state);
      console.log('RE Investor Table - Source collection:', sourceCollection);
      console.log('RE Investor Table - Target collection:', targetCollection);
      console.log('RE Investor Table - Search query:', searchQuery);
      console.log('RE Investor Table - Search type:', searchType);
      
      // Check if we need a fresh search
      const needsFreshSearch = targetCollection && 
        (searchQuery !== undefined && searchType !== undefined) &&
        (!globalSearchResult?.[targetCollection] || globalSearchResult[targetCollection].length === 0);
      
      console.log(`RE Investor Table: Target collection: ${targetCollection}, Needs fresh search: ${needsFreshSearch}`);
      
      // If we have search parameters and need a fresh search, perform it
      if (targetCollection && searchQuery !== undefined && searchType !== undefined && 
          (needsFreshSearch || isFromGlobalSearchFlag)) {
        const searchResultCount = resultCount || 1000;
        
        console.log(`RE Investor Table: Performing fresh search for collection: ${targetCollection}`);
        
        try {
          const { getSearchResultIdsAll } = await import('../../../../Components/useGlobalSearch');
          
          const freshSearchResults = await getSearchResultIdsAll(
            searchQuery,
            searchResultCount,
            searchType,
            [targetCollection]
          );
          
          console.log(`RE Investor Table: Fresh search results for ${targetCollection}:`, freshSearchResults);
          
          setGlobalSearchResult(freshSearchResults);
          
          if (freshSearchResults && freshSearchResults[targetCollection]?.length > 0) {
            const investorIds = (freshSearchResults[targetCollection] || []).map(id => parseInt(id));
            const companyIds = (freshSearchResults.re_investor_cmp_ids || []).map(id => parseInt(id));
            
            return {
              investorIds: investorIds.length > 0 ? investorIds : [0],
              companyIds: companyIds
            };
          }
        } catch (error) {
          console.error('RE Investor Table: Error performing fresh search:', error);
        }
      }
      
      // Fallback to existing global search results
      if (targetCollection && globalSearchResult?.[targetCollection]?.length > 0) {
        console.log(`RE Investor Table: Using existing IDs from collection: ${targetCollection}`, globalSearchResult[targetCollection]);
        const investorIds = (globalSearchResult[targetCollection] || []).map(id => parseInt(id));
        const companyIds = (globalSearchResult.re_investor_cmp_ids || []).map(id => parseInt(id));
        
        return {
          investorIds: investorIds.length > 0 ? investorIds : [0],
          companyIds: companyIds
        };
      }
      
      // Final fallback to category-based existing results
      if (globalSearchResult?.re_investor?.length > 0) {
        console.log('RE Investor Table: Using re_investor IDs (fallback):', globalSearchResult.re_investor);
        const investorIds = (globalSearchResult.re_investor || []).map(id => parseInt(id));
        const companyIds = (globalSearchResult.re_investor_cmp_ids || []).map(id => parseInt(id));
        return { investorIds: investorIds.length > 0 ? investorIds : [0], companyIds };
      }
      
      console.log('RE Investor Table: No matching IDs found, using default [0]');
      return { investorIds: [0], companyIds: [] };
    } catch (error) {
      console.error('RE Investor Table: Error fetching global search IDs:', error);
      return { investorIds: [0], companyIds: [] };
    }
  };


/* The above code is a JavaScript function that uses the axios library to make an HTTP POST request to
an API endpoint. The function takes several parameters including page, month, column, order, and
groupId. It then constructs the request payload based on the values of these parameters and other
variables. The function also includes headers with an authorization token. */
  const tableRender = useCallback(async (page, month, column, order ,groupId) => {
    // Get IDs for global search if needed
    let companyIds = refineSearchFilters[location.pathname]?.target_company?.map(company => company.id);
    let investorIds = null;
    
    if (isFromGlobalSearch() || location.state?.isFromGlobalSearch || 
        (globalSearchResult && Object.keys(globalSearchResult).length > 0)) {
      console.log('RE Investor Table: Fetching global search IDs');
      console.log('RE Investor Table: Location state:', location.state);
      console.log('RE Investor Table: Global search result keys:', Object.keys(globalSearchResult || {}));
      const searchIds = await getGlobalSearchIds();
      console.log('RE Investor Table: Received searchIds:', searchIds);
      companyIds = searchIds.companyIds;
      investorIds = searchIds.investorIds;
      console.log('RE Investor Table: Using global search company IDs:', companyIds);
      console.log('RE Investor Table: Using global search investor IDs:', investorIds);
    } else {
      console.log('RE Investor Table: NOT from global search');
    }

    axios(reInvestorListUrl, {
      method: "POST",
      signal: abortControllerRef.current.signal,
      data: locState ? locState : { 
        "category": category,
        from : isFromGlobalSearch() || location.state?.isFromGlobalSearch || 
               (globalSearchResult && Object.keys(globalSearchResult).length > 0) ? 'gs' : '',
        date_range: {
                from_date: moment(month[0]).format("YYYY-MM-DD"),
                to_date: moment(month[1]).format("YYYY-MM-DD"),
              },
        "order_by": {
          "column": column,
          "direction": order 
        },
        "page":page,
        // operator : refineSearchFilters[location.pathname]?.deals_operator,
        company_ids : companyIds,
        ladvisor_ids : category === "angel" || category === "incubation" ? [] : refineSearchFilters[location.pathname]?.ladvisors?.map(acq => acq.id)  ,
        tadvisor_ids : category === "angel" || category === "incubation" ? [] : refineSearchFilters[location.pathname]?.tadvisors?.map(acq => acq.id)  ,
        investor_ids: investorIds !== null ? investorIds : refineSearchFilters[location.pathname]?.investor_id?.map(acq => acq.id),
        "city": refineSearchFilters[pathKey]?.city?.map(city => city.id),
        "deal_range": refineSearchFilters[pathKey]?.dealRange?.at(0) && {
          "from": refineSearchFilters[pathKey]?.dealRange[0].name,
          "to": refineSearchFilters[pathKey]?.dealRange[1].name
        },
        "investor_type": refineSearchFilters[location.pathname]?.investorType?.map(type => type.id),
        "type": refineSearchFilters[location.pathname]?.fundSector?.map(sector => sector.id),
        "sub_sector": refineSearchFilters[location.pathname]?.subSector?.map(sector => sector.id)
        ,
        group:{  
          group_id: groupId?.myList?.map(id => id.group_id)?.toString() ?? null,
          sub_type_master_id: groupId?.myList?.length >0 ? sub_type_master_id :null   
    }, 

      }, 
        
      headers: {
        "Authorization": getToken()
      }
    }).then(response => {
      if (response?.data?.message == "Success") {
        setCurrentFilter(response.config.data)
        setIsLoading(false)
        setIsDataLoad(false)
        setRows(response?.data?.investors)
        setTableInvestorId(response?.data?.all_investor_ids)
        setAllDealIds(response?.data?.all_deal_ids)
        setData(response?.data)
        // console.log(response?.data?.companies,"api")
      }
    })
      .catch((error) => {
        if (error?.response?.status == Constants.sessionTerminatedStatus 
            || error?.response?.status == Constants.InvalidTokenStatus
          ){
          logout();
        }
        console.log("API not working", error);
      });
  }, [monthPickerValue, refineSearchFilters]);


  useEffect(() => {
    const abortController = new AbortController();
    abortControllerRef.current = abortController;
    setIsLoading(true)
    setIsDataLoad(true)
    setCurrentPage(currentPage)
    tableRender(currentPage, monthPickerValue, sort.orderBy, sort.order,groupId)
    return () => abortController.abort();
  }, [monthPickerValue, refineSearchFilters ,groupId ,reload]);


  const rowsMemo = useMemo(() => rows, [rows])
  const count = rowsMemo?.length

/**
 * The function `handleSort` is used to handle sorting of data in a table based on a given accessor and
 * order.
 * @param accessor - The `accessor` parameter is a value that represents the property or key of the
 * object that you want to sort by. It is used to identify the specific property or key in the object
 * that you want to sort on.
 * @param order - The "order" parameter is used to specify the sorting order. It can have two possible
 * values: 'asc' for ascending order and 'desc' for descending order.
 */
  const handleSort = (accessor) => {
  setCurrentPage(currentPage);
  setRows([]);
  setIsLoading(true);
  setIsDataLoad(true);

  const isNumericColumn = ["project_count","deals","exited_project_count","ipos","latest_ipo_size"].includes(accessor);

  setSort((prevSort) => {
    const isSameColumn = prevSort.orderBy === accessor;
    const newOrder = isSameColumn
      ? prevSort.order === "desc" ? "asc" : "desc"
      : isNumericColumn ? "desc" : "asc"; // Default to 'desc' for numeric columns, 'asc' for others

    tableRender(
      currentPage,
      monthPickerValue,
      accessor,
      newOrder,
      groupId
    );

    return {
      order: newOrder,
      orderBy: accessor,
    };
  });
};

 /**
  * The function `addCommasToNumber` takes a number as input and returns a string representation of the
  * number with commas added for thousands separators.
  * @param number - The `number` parameter is the number to which commas need to be added.
  * @returns The function `addCommasToNumber` returns a string with commas added to the number.
  */
  const addCommasToNumber = (number) => {
    return number?.toString()?.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  };

  return (
    <div className={`pl-3 ${rows?.length > 5 ? 'pr-2':'pr-4'}`}>
      <div className="md:col-span-4 col-span-5">
        <div className="lg:col-span-4">
          <div className="scrollbar ">
            <div className={"overflow-x-auto scrollbar rounded rounded-[6px] rounded-t-none shadow-[0_2px_6px_0_rgba(0,0,0,0.08)] "+(rows?.length > 5 ? '':'')}>
              <table className="w-full p-1 bg-grey-50 divide-y">
                <thead className="bg-[#EBEBEB] text-[11pt] leading-[16pt] lg:text-[13px] lg:leading-[15px] font-sans_semi_bold text-[#666666]  text-left">
                  <tr>
                    {columns.map((column, i) => {
                      const sortIcon = () => {
                        if (column.accessor === sort.orderBy) {
                          if (sort.order === 'asc') {
                            return <SortDescendingIcon className="pl-2 block h-[15px]" />
                          }
                          return <SortAscendingIcon className="pl-2 block h-[15px]" />
                        } else {
                          return <SortIcon className="pl-2 block h-[15px] " />
                        }
                      }
                      return (
                        <th className="title px-5 py-2 font-sans_book_body" key={i}>
                          <span className={`flex ${column.className} ${column.accessor === "top_project_companies" ? 'justify-center' : ''}`}>
                            <OverflowToolTip component={
                              <a className='cursor-text hover:text-[#000000]'>
                                {column.accessor === "add" && groupId?.myList?.length > 0 ? "Delete" :
                                  column.accessor === "add" ? (
                                    <div className="flex flex-col text-center">
                                      <span>Create</span>
                                      <span>your list</span>
                                    </div>
                                  ) 
                                  : column.accessor === "last_investment_at_sort" ? (
                                    <div className="flex flex-col text-center">
                                      <span>Last Investment</span>
                                      <span>Made</span>
                                    </div>
                                  ) 
                                  : column.accessor === "top_project_companies" ? (
                                    <div className="flex flex-col text-center  ">
                                      <span>Top projects cos based on</span>
                                      <span>investment size</span>
                                    </div>
                                  ) 
                                  : column.accessor === "exited_project_count" ? (
                                    <div className="flex flex-col text-center  ">
                                      <span>Exited Projects</span>
                                      <span>(Partial/Full)</span>
                                    </div>
                                  ) 
                                  : column.accessor === "latest_ipo_size" ? (
                                    <div className="flex flex-col text-center  ">
                                      <span>Latest IPO Size</span>
                                      <span>(US$ M)</span>
                                    </div>
                                  ) 
                                  : column.label ? column.label : "--"}
                              </a>
                            } />
                            {column.accessor !== "add" && (
                              <button onClick={() => handleSort(column.accessor, sort.order)}>
                                {sortIcon()}
                              </button>
                            )}
                          </span>
                        </th>
                      )
                    })}
                  </tr>
                </thead>
                {!isLoading ?
                  count > 0 ?
                    <tbody className="text-[13pt] leading-[16pt] lg:text-[14px] lg:leading-[16px] text-[#333333] text-left font-sans_book_body">
                      {rowsMemo.length > 0 ?
                        rowsMemo?.map((row, i) => {
                          if (category === "re-investments") {
                            return (
                              <tr key={row.InvestorId} className=" group hover:border-l-4 hover:border-l-[#BC8B20] border-l-4 border-l-[#FFFFFF]  border-b bg-white text">
                              <td className="md:w-[23%] pl-5 leading-[2rem] text-left sticky left-0 lg:relative text-[#333333] bg-white py-3 font-sans_book_body items-center justify-center">
                              <NewLogo id={row.InvestorId} menu={"re_investor"} name={row.Investor} />
                                <div className="whitespace-normal break-words">
                                  <OverflowToolTip
                                    className="w-[10rem] md:w-[10rem] lg:w-auto lg:max-w-[13rem] 2xl:max-w-[30rem] flex flex-row gap-2"
                                    component={
                                      <NavLink
                                        className="flex text-start leading-[1.8rem] lg:inline whitespace-normal break-words hover:text-[#BC8B20] font-medium"
                                        state={{ prevPath: location.pathname }}
                                        to={{
                                          pathname: routeNames.reInvestorById(row.InvestorId),
                                          search: getSection(Constants.primaryMasterSubIds.re_investor_investment_id),
                                        }}
                                      >
                                        {row?.Investor ? row.Investor : "--"}
                                      </NavLink>
                                    }
                                  />
                                </div>
                              </td>
                                <td width="4%" className='whitespace-nowrap pr-[2.8rem] py-3 font-[Squel Sans] text-right'>{row?.project_count !=0 ? addCommasToNumber(row.project_count) :"--"}</td>
                                <td width="30%" className="whitespace-normal break-words font-medium px-5 py-3 font-[Squel Sans]">
                                  {row?.top_project_companies_detail?.length > 0 ? (
                                    <TwolineOverflowToolTip
                                      className="sm:max-w-[17rem] 2xl:max-w-[30rem] line-clamp-2 leading-relaxed"
                                      component={
                                        <span className="whitespace-normal break-words">
                                          {row?.top_project_companies_detail?.map((detail, index) => (
                                            <Link
                                              key={detail?.company_id}
                                              className="hover:text-primaryColor"
                                              to={{
                                                pathname: routeNames.reCompanyById(detail?.company_id),
                                                search: getSection(Constants.primaryMasterSubIds.re_investor_investment_id),
                                              }}
                                            >
                                              {detail?.company_name}
                                              {index !== row?.top_project_companies_detail?.length - 1 ? ", " : ""}
                                            </Link>
                                          ))}
                                        </span>
                                      }
                                    />
                                  ) : (
                                    "--"
                                  )}
                                </td>

                                <td width="28%" className="whitespace-normal break-words font-medium px-5 py-3 font-[Squel Sans]">
                                  {row?.last_invested_in ? (
                                    <TwolineOverflowToolTip
                                      className="sm:max-w-[17rem] 2xl:max-w-[30rem] line-clamp-2 leading-relaxed"
                                      component={
                                        <Link
                                          className="hover:text-primaryColor whitespace-normal break-words"
                                          to={{
                                            pathname: routeNames.reCompanyById(row?.last_invested_in?.company_id),
                                            search: getSection(Constants.primaryMasterSubIds.re_investor_investment_id),
                                          }}
                                        >
                                          {row?.last_invested_in?.company_name}
                                        </Link>
                                      }
                                    />
                                  ) : (
                                    "--"
                                  )}
                                </td>

                                <td width="5%" className='whitespace-nowrap font-medium px-5 py-3 font-[Squel Sans] '>

                                <OverflowToolTip component={<Link
                                            className='hover:text-[#BC8B20]'
                                            
                                            to={{
                                              pathname: routeNames.reCompanyInvestmentDealById(row?.last_invested_in?.company_id, row?.last_investment_at_id)
                                            }}
                                          >{row?.last_investment_at? row.last_investment_at: "--"}</Link>} />
                                  
                                  </td>
                                <td width="3%" className='whitespace-nowrap  px-5 py-3 font-[Squel Sans]'>
                                {groupId?.myList?.length >0 ? 
                                 <DeleteItemsFromGroup id={row.company_id} group_id={row?.grp_lt_item_id} type_id={Constants.moduleIds.investorsId} setReload={setReload}/>
                                 :  <AddNotePopover key={row.InvestorId} companyId={row.InvestorId} companyName={row.Investor} type_id={Constants.moduleIds.investorsId} sub_type_master_id={sub_type_master_id}/>
                          }</td>
                              </tr>
                            )
                          } else if (category === "re-exits") {
                            return (
                              <tr className=" group hover:border-l-4 hover:border-l-[#BC8B20] border-l-4 border-l-[#FFFFFF]  border-b bg-white text" key={i}>
                              <td className="md:w-[32%] pl-5 leading-[2rem] text-left sticky left-0 lg:relative text-[#333333] bg-white py-3 font-sans_book_body items-center justify-center">
                              <NewLogo id={row.InvestorId} menu="re_investor" name={row.Investor} />
                                <div className="whitespace-normal break-words">
                                  <OverflowToolTip
                                    className="w-[10rem] md:w-[10rem] lg:w-auto lg:max-w-[13rem] 2xl:max-w-[30rem] flex flex-row gap-2"
                                    component={
                                      <Link
                                        className="flex text-start leading-[1.8rem] lg:inline whitespace-normal break-words hover:text-[#BC8B20] font-medium"
                                        state={{ prevPath: location.pathname }}
                                        to={{
                                          pathname: routeNames.reInvestorById(row.InvestorId),
                                          search: getSection(Constants.primaryMasterSubIds.re_investor_exits_id),
                                        }}
                                      >
                                        {row?.Investor ? row.Investor : "--"}
                                      </Link>
                                    }
                                  />
                                </div>
                              </td>
                                <td className='whitespace-nowrap  px-5 py-3 font-[Squel Sans] w-[5%] text-right pr-[3.2rem]'>{row?.exited_project_count !=0 ? addCommasToNumber(row.exited_project_count) :"--"}</td>
                                <td className="whitespace-normal break-words font-medium px-5 py-3 font-[Squel Sans] w-[25%]">
                                  {(row?.top_exits_detail?.length ?? 0) > 0 ? (
                                    <TwolineOverflowToolTip
                                      className="sm:max-w-[17rem] 2xl:max-w-[30rem] line-clamp-2 leading-relaxed"
                                      component={
                                        <span className="whitespace-normal break-words">
                                          {row?.top_exits_detail?.map((detail, index) => (
                                            <Link
                                              key={detail?.company_id}
                                              className="hover:text-primaryColor"
                                              to={{
                                                pathname: routeNames.reCompanyById(detail?.company_id),
                                                search: getSection(Constants.primaryMasterSubIds.re_investor_investment_id),
                                              }}
                                            >
                                              {detail?.company_name}
                                              {index !== row?.top_exits_detail?.length - 1 ? ", " : ""}
                                            </Link>
                                          ))}
                                        </span>
                                      }
                                    />
                                  ) : (
                                    "--"
                                  )}
                                </td>
                                <td className="whitespace-normal break-words font-medium px-5 py-3 font-[Squel Sans] w-[32%]">
                                  {row?.last_exited_in ? (
                                    <TwolineOverflowToolTip
                                      className="sm:max-w-[17rem] 2xl:max-w-[30rem] line-clamp-2 leading-relaxed"
                                      component={
                                        <Link
                                          className="hover:text-primaryColor whitespace-normal break-words"
                                          to={{
                                            pathname: routeNames.reCompanyById(row?.last_exited_in?.company_id),
                                            search: getSection(Constants.primaryMasterSubIds.re_investor_exits_id),
                                          }}
                                        >
                                          {row?.last_exited_in?.company_name}
                                        </Link>
                                      }
                                    />
                                  ) : (
                                    "--"
                                  )}
                                </td>
                                <td className='whitespace-nowrap  px-5 py-3 font-[Squel Sans] w-[5%]'>
                                {groupId?.myList?.length >0 ? 
                                 <DeleteItemsFromGroup id={row.company_id} group_id={row?.grp_lt_item_id} type_id={Constants.moduleIds.investorsId} setReload={setReload}/>
                                 :  <AddNotePopover key={row.InvestorId} companyId={row.InvestorId} companyName={row.Investor} type_id={Constants.moduleIds.investorsId} sub_type_master_id={sub_type_master_id}/>
                                 } </td>
                              </tr>
                            )
                          } else {
                            return (
                              <tr className=" group hover:border-l-4 hover:border-l-[#BC8B20] border-l-4 border-l-[#FFFFFF]  border-b bg-white text" key={i}>
                                <td className="md:w-[33%] pl-5 leading-[2rem] text-left sticky left-0 lg:relative text-[#333333] bg-white py-3 font-sans_book_body items-center justify-center">
                                <NewLogo id={row.InvestorId} menu="re_investor" name={row.Investor} />
                                  <div className="whitespace-normal break-words">
                                    <OverflowToolTip
                                      className="w-[10rem] md:w-[10rem] lg:w-auto lg:max-w-[13rem] 2xl:max-w-[30rem] flex flex-row gap-2"
                                      component={
                                        <Link
                                          className="flex text-start leading-[1.8rem] lg:inline whitespace-normal break-words hover:text-[#BC8B20] font-medium"
                                          state={{ prevPath: location.pathname }}
                                          to={{
                                            pathname: routeNames.reInvestorById(row.InvestorId),
                                            search: getSection(Constants.primaryMasterSubIds.re_investor_ipo_id),
                                          }}
                                        >
                                          {row?.Investor ? row.Investor : "--"}
                                        </Link>
                                      }
                                    />
                                  </div>
                                </td>
                                <td className='whitespace-nowrap  px-5 py-3 font-[Squel Sans] w-[5%] pl-10'>{row.ipos !=0 ? addCommasToNumber(row.ipos) :"--"}</td>
                                <td className="whitespace-normal break-words font-medium px-5 py-3 font-[Squel Sans] w-[35%]">
                                  {row?.latest_ipo ? (
                                    <TwolineOverflowToolTip
                                      className="sm:max-w-[17rem] 2xl:max-w-[30rem] line-clamp-2 leading-relaxed"
                                      component={
                                        <Link
                                          className="hover:text-primaryColor whitespace-normal break-words"
                                          to={{
                                            pathname: routeNames.reCompanyById(row?.latest_ipo?.company_id),
                                            search: getSection(Constants.primaryMasterSubIds.re_investor_ipo_id),
                                          }}
                                        >
                                          {row?.latest_ipo?.company_name}
                                        </Link>
                                      }
                                    />
                                  ) : (
                                    "--"
                                  )}
                                </td>
                                <td className='whitespace-nowrap  px-5 py-3 font-[Squel Sans] text-center lg:pl-[9%] xl:pl-[8.5%] 2xl:pl-[7%] w-[15%]'>{row?.latest_ipo_size !=0 || row.latest_ipo_size !=0.00 ? addCommasToNumber(row.latest_ipo_size) : "--"}</td>
                                <td className='whitespace-nowrap font-medium px-5 py-3 font-[Squel Sans] w-[5%]'>
                                {groupId?.myList?.length >0 ? 
                                 <DeleteItemsFromGroup id={row.company_id} group_id={row?.grp_lt_item_id} type_id={Constants.moduleIds.investorsId} setReload={setReload}/>
                                 :  <AddNotePopover key={row.InvestorId} companyId={row.InvestorId} companyName={row.Investor} type_id={Constants.moduleIds.investorsId} sub_type_master_id={sub_type_master_id}/>
                          }</td>
                              </tr>
                            )
                          }
                        })
                        : <center><div className="h-[4rem] text-[12pt] lg:text-[15px] text-[#333333] relative mt-[3rem] left-[30rem]">No data found</div></center>
                      }
                    </tbody>
                    : <></>
                  : <></>
                }
              </table>
              {!isLoading ?
                count > 0 ?
                  <></>
                  : 
                    <div className='w-full h-[17rem] bg-white flex items-center justify-center fixed md:relative'>
                      <NoDataPlaceholder />
                    </div>                  
                :
                <div className='w-full h-[17rem] bg-white flex items-center justify-center absolute md:relative'>
                  <Loader />
                </div>
              }
            </div>
          </div>
        </div>
      </div>

    <div className={'pb-[9.25rem] lg:pb-[7.25rem]'}>{data?.num_investors && rows.length > 0 ? (
        <Pagination
          className="pagination-bar "
          currentPage={currentPage}
          totalCount={data?.num_investors}
          pageSize={20}
          onPageChange={(page) => findActivePage(page)}
          allDataRoute={`${location?.pathname}/all`}
          refineSearchFilters={refineSearchFilters}
          monthPickerValue={monthPickerValue}
        />

      ) : (
        ""
      )}
      </div>  
    </div>
  )
} 

export default Table